import React from "react";
import { Link } from "react-router-dom";

const NotFound = () => {
  return (
    <div style={styles.container}>
      <h1 style={styles.code}>404</h1>
      <h2 style={styles.title}>Page Not Found</h2>
      <p style={styles.text}>
        The page you’re looking for doesn’t exist or was moved.
      </p>
    </div>
  );
};

const styles = {
  container: {
    height: "100vh",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    background: "#0f172a",
    color: "#fff",
    textAlign: "center",
    padding: "20px",
  },
  code: {
    fontSize: "96px",
    margin: 0,
    fontWeight: "700",
  },
  title: {
    fontSize: "28px",
    marginBottom: "10px",
  },
  text: {
    fontSize: "16px",
    opacity: 0.8,
    marginBottom: "20px",
  },
  button: {
    padding: "12px 24px",
    background: "#2563eb",
    color: "#fff",
    borderRadius: "6px",
    textDecoration: "none",
    fontWeight: "500",
  },
};

export default NotFound;
